import axios from 'axios';

import { PaginatedApiResponse } from 'api/_types';
import type { OrderServiceOrigins } from 'constants/_types/OrderServiceOrigins';
import createUrlWithParams from 'helpers/createUrlWithParams/createUrlWithParams';

import { endpoint } from '../coreServiceSubtypes';
import type { CoreServiceSubtype, CoreServiceSubtypeDTO } from '../coreServiceSubtypes.types';
import { parseServiceSubtypesForFE } from './_services/parseServiceSubtypesForFE/parseServiceSubtypesForFE';
import { prepareParamsForGetServiceSubtypes } from './_services/prepareParamsForGetServiceSubtypes/prepareParamsForGetServiceSubtypes';

export interface Params {
  patientId: number;
  policyId?: number;
  serviceOrigin?: OrderServiceOrigins;
  masterType?: string;
  masterTypeIsNull?: boolean;
  payers: (string | number)[] | undefined;
  pro?: boolean;
}

type GetServiceSubtypesQuery = () => Promise<CoreServiceSubtype[]>;

export const getServiceSubtypes =
  ({ patientId, serviceOrigin, masterType, masterTypeIsNull, payers, pro, policyId }: Params) =>
  async () => {
    const { data } = await axios.get<GetServiceSubtypesQuery, PaginatedApiResponse<CoreServiceSubtypeDTO>>(
      createUrlWithParams({
        url: endpoint,
        params: prepareParamsForGetServiceSubtypes({ patientId, serviceOrigin, masterType, masterTypeIsNull, payers, pro, policyId }),
      }),
    );

    return parseServiceSubtypesForFE(data.results);
  };
